import MainFooter from "@/components/MainFooter/MainFooter.vue";

export default {
  components: {
    MainFooter,
  },
  data() {
    return {
      mainProps: { width: 200, height: 50, class: "m1" },
    };
  },
  methods: {},
  beforeCreate() {
    this.$store.dispatch("auth/CREATE_LAYOUT_INSTANCE");
  },
};
